import http from 'utils/http';
import {
  SentimentsSummaryResponse,
  AuditNeededCallsResponse,
  IssueContextsResponse,
  ToolErrorsResponse,
  ResponseTimesResponse,
  SynchronizerLogsResponse
} from './types';
import {
  getSentimentsSummaryUrl,
  getAuditNeededCallsUrl,
  getIssueContextsUrl,
  getToolErrorsUrl,
  getResponseTimesUrl,
  getSynchronizerLogsUrl
} from './apiUrls';

export function getSentimentsSummary(params: Record<string, any>): Promise<SentimentsSummaryResponse> {
  return http.get(getSentimentsSummaryUrl(), params);
}

export function getAuditNeededCalls(params: Record<string, any>): Promise<AuditNeededCallsResponse> {
  return http.get(getAuditNeededCallsUrl(), params);
}

export function getIssueContexts(): Promise<IssueContextsResponse> {
  return http.get(getIssueContextsUrl());
}

export function getToolErrors(params: Record<string, any>): Promise<ToolErrorsResponse> {
  return http.get(getToolErrorsUrl(), params);
}

export function getResponseTimes(params: Record<string, any>): Promise<ResponseTimesResponse> {
  return http.get(getResponseTimesUrl(), params);
}

export function getSynchronizerLogs(params: Record<string, any>): Promise<SynchronizerLogsResponse> {
  return http.get(getSynchronizerLogsUrl(), params);
}
